import React, { useContext } from 'react';
import { graphql } from 'gatsby';
import SupportMasthead from './SupportMasthead';
import {
    CTAConfiguration,
    KontentRadioMultiChoice,
    BrandColor,
    KontentMedia,
    KontentStringValue,
    CTALocation,
} from '../../../types/KontentProps';
import { ProductFamily } from '../../templates/StructuredDataContext';
//@ts-ignore
import { useProductFamilies } from '../Global/DataUtils/productFamiliesQueries';
import { PageMetadataContext } from '../../templates/PageMetaDataContext';
import { useSupport } from '../Global/DataUtils/supportQueries';

type ShowHide = 'show' | 'hide';
type ContentPosition = 'Left' | 'Right' | 'Center';

export interface MappedProductFamily {
    familyName?: string;
    familyId?: string;
    products: {
        productName?: string;
        productUrl?: string;
        productId?: string;
    }[];
}

type HeaderTagType = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p';

export interface SupportMastheadProps extends CTAConfiguration {
    content_position: KontentRadioMultiChoice<ContentPosition>;
    general_large___small_image_selection__large?: KontentMedia;
    general_large___small_image_selection__small?: KontentMedia;
    ghosted_icon_image?: KontentMedia;
    headline: KontentStringValue;
    headline_tag: KontentRadioMultiChoice<HeaderTagType>;
    headline_style: KontentRadioMultiChoice<HeaderTagType>;
    general_search_hint_text: KontentStringValue;
    general_search_subheadline: KontentStringValue;
    product_selection_hint_text: KontentStringValue;
    product_selection_subheadline: KontentStringValue;
    under_image_bar_color: BrandColor;
    under_image_bar_show_or_hide: KontentRadioMultiChoice<ShowHide>;
    search_results_page: CTALocation;
}

const SupportMastheadContainer: React.FC<SupportMastheadProps> = (props) => {
    const productFamilies = useProductFamilies();
    const pageMetadata = useContext(PageMetadataContext);
    const prodFamilySupportPages = mapSupportPagesToProductFamilies(
        productFamilies,
        pageMetadata.preferredLanguage
    ).sort((leftFamily, rightFamily) =>
        leftFamily.familyName.localeCompare(rightFamily.familyName)
    ); //returning product family
    const supportProducts = mapSupportProdToProdFamily(
        productFamilies,
        pageMetadata.preferredLanguage
    );

    return (
        <SupportMasthead
            productFamilyContent={prodFamilySupportPages}
            supportProducts={supportProducts}
            preferredLanguage={pageMetadata?.preferredLanguage}
            {...props}
        />
    );
};

function mapSupportProdToProdFamily(
    productFamilies: ProductFamily[],
    preferredLanguage: string | undefined
) {
    const supportPages = useSupport().filter(
        (page) =>
            page.preferred_language.toLowerCase() ===
            preferredLanguage?.toLowerCase()
    );

    const supportPagesByProductSlug = {};

    supportPages.map((supportPage) => {
        const productSupportLayout =
            supportPage.elements.page_components.value.filter((component) => {
                //@ts-ignore
                return (
                    component?.__typename ===
                    'kontent_item_component___product_support_layout'
                );
            })[0];

        if (!productSupportLayout) return;
        const slug =
            productSupportLayout.elements?.product_0acaef2?.value[0]?.elements
                .slug.value;

        if (!slug) return;
        return (supportPagesByProductSlug[slug] = supportPage);
    });
    return productFamilies.map((family: any) => {
        const prodsWithSupportPage: MappedProductFamily['products'] = [];
        family.elements.support_products.value.map((product: any) => {
            const name =
                product.elements.page_components?.value?.filter(
                    (element: any) => {
                        return (
                            element.__typename ==
                            'kontent_item_component___product_detail_masthead'
                        );
                    }
                )[0]?.elements?.display_headline?.value ||
                product.elements.page_components?.value?.filter(
                    (element: any) => {
                        return (
                            element.__typename ==
                            'kontent_item_component___global_masthead'
                        );
                    }
                )[0]?.elements?.display_headline?.value ||
                product.elements?.display_page_name?.value;

            const supportPage =
                supportPagesByProductSlug[product.elements.slug.value];

            if (!supportPage) return;

            const url = supportPage.elements?.slug.url;

            prodsWithSupportPage.push({
                productName: name,
                productUrl: url,
                productId: product.id,
            });
        });

        return {
            familyName: family.elements.product_family.value[0]?.name,
            products: prodsWithSupportPage,
            familyId: family.id,
        };
    });
}

function mapSupportPagesToProductFamilies(
    productFamilies: ProductFamily[],
    preferredLanguage: string | undefined
) {
    const supportPages = useSupport().filter(
        (page) =>
            page.preferred_language.toLowerCase() ===
            preferredLanguage?.toLowerCase()
    );

    const supportPagesByProductSlug = {};

    supportPages.map((supportPage) => {
        const productSupportLayout =
            supportPage.elements.page_components.value.filter((component) => {
                //@ts-ignore
                return (
                    component?.__typename ===
                    'kontent_item_component___product_support_layout'
                );
            })[0];

        if (!productSupportLayout) return;
        const slug =
            productSupportLayout.elements?.product_0acaef2?.value[0]?.elements
                .slug.value;

        if (!slug) return;
        return (supportPagesByProductSlug[slug] = supportPage);
    });
    return productFamilies.map((family) => {
        const prodsWithSupportPage: MappedProductFamily['products'] = [];
        family.elements.products.value.map((product) => {
            const name =
                product.elements.page_components?.value?.filter((element) => {
                    return (
                        element.__typename ==
                        'kontent_item_component___product_detail_masthead'
                    );
                })[0]?.elements?.display_headline?.value ||
                product.elements.page_components?.value?.filter((element) => {
                    return (
                        element.__typename ==
                        'kontent_item_component___global_masthead'
                    );
                })[0]?.elements?.display_headline?.value ||
                product.elements?.display_page_name?.value;

            const supportPage =
                supportPagesByProductSlug[product.elements.slug.value];

            if (!supportPage) return;

            const url = supportPage.elements?.slug.url;

            prodsWithSupportPage.push({
                productName: name,
                productUrl: url,
                productId: product.id,
            });
        });

        return {
            familyName: family.elements.product_family.value[0]?.name,
            products: prodsWithSupportPage,
            familyId: family.id,
        };
    });
}

export default SupportMastheadContainer;

export const fragmentSupportMastHead = graphql`
    fragment SupportMasthead on kontent_item_component___support_masthead {
        elements {
            content_position {
                value {
                    codename
                }
            }
            cta_configuration__cta_label {
                value
            }
            cta_configuration__cta_location {
                ...kontentCtaLocation
            }
            cta_configuration__cta_location_anchor_point {
                value
            }
            cta_configuration__cta_window_action {
                value {
                    name
                }
            }
            headline_tag {
                value {
                    codename
                    name
                }
            }
            headline_style {
                value {
                    name
                    codename
                }
            }
            general_large___small_image_selection__large {
                ...kontentImage
            }
            general_large___small_image_selection__small {
                ...kontentImage
            }
            ghosted_icon_image {
                ...kontentImage
            }
            general_search_hint_text {
                value
            }
            general_search_subheadline {
                value
            }
            headline {
                value
            }
            product_selection_hint_text {
                value
            }
            product_selection_subheadline {
                value
            }
            under_image_bar_color {
                ...kontentColor
            }
            under_image_bar_show_or_hide {
                value {
                    codename
                }
            }
            search_results_page {
                value {
                    ... on kontent_item_layout___master_page {
                        id
                        elements {
                            slug {
                                url
                            }
                        }
                    }
                }
            }
        }
    }
`;
